/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-nested-ternary */
class UnLive {
  setup = (isExternal) => {
    this.init();
    this.listeners = {};
    this.isExternal = isExternal;
  };

  init = () => {
    if (window.addEventListener) {
      window.addEventListener('message', this.listener, false);
    } else {
      window.attachEvent('onmessage', this.listener);
    }
  };

  addListener = (event, cb) => {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(cb);
  };

  callMethod = () => {};

  cleanup = () => {
    if (window.removeEventListener) {
      window.removeEventListener('message', this.listener, true);
    } else {
      window.detachEvent('onmessage', this.listener);
    }
    this.listeners = {};
  };

  listener = (e) => {
    if (e && e.data) {
      /**
       * Sending up the message for Graphy
       */
      if (this.isExternal && window.parent && window.parent !== window) {
        window.parent.postMessage(e.data, '*');
      }
      let { event } = e.data;
      const data =
        event === 'UPDATE_CLASS_START_TIME'
          ? e.data.status.currentTime
          : event === 'WATCHED'
          ? e.data.status.playedDuration
          : 0;
      const isReplay = e.data && e.data.status && e.data.status.isReplay;
      const isLiveDVR = e.data && e.data.status && e.data.status.isLiveDVR;
      const isLive = e.data && e.data.status && e.data.status.isLive;
      let isPlaying = false;

      if (event === 'pause') {
        isPlaying = false;
      } else if (event === 'play') {
        isPlaying = true;
      }
      if (event === 'pause' || event === 'play') {
        event = 'playing';
      }
      if (this.listeners[event]) {
        Object.keys(this.listeners[event]).forEach((key) => {
          this.listeners[event][key](
            event,
            isPlaying,
            data,
            isReplay,
            isLiveDVR,
            isLive
          );
        });
      }
    }
  };
}

export default UnLive;
